(function () {
  // Two ways to arm a click target:
  //  1) the theme's own rating block in product-info (legacy, matched by convention),
  //  2) ANY element carrying data-scroll-to-reviews (explicit opt-in for custom layouts).
  const CLICK_SELECTOR = '[data-scroll-to-reviews], .product-info__block-item[data-block-type="rating"] .rating-badge';
  // Scroll target: own review app (.review-app) has PRIORITY; Okendo selectors kept as a
  // fallback for the transition period — remove them once Okendo is fully gone.
  // (Order matters: a comma list in querySelector returns the first match in DOM order,
  // so the priority is enforced in scrollToReviewsWithOffset, not here.)
  const TARGET_SELECTORS = ['.review-app', '[data-oke-widget], .okeReviews'];

  // Ile px NAD sekcją ma się zatrzymać (dopasuj)
  const OFFSET_PX = 160;

  function scrollToReviewsWithOffset() {
    let target = null;
    for (const selector of TARGET_SELECTORS) {
      target = document.querySelector(selector);
      if (target) break;
    }
    if (!target) return;

    const y = target.getBoundingClientRect().top + window.pageYOffset - OFFSET_PX;

    window.scrollTo({
      top: Math.max(y, 0),
      behavior: 'smooth'
    });
  }

  document.addEventListener('click', function (e) {
    const clicked = e.target.closest(CLICK_SELECTOR);
    if (!clicked) return;

    e.preventDefault();
    scrollToReviewsWithOffset();
  });
})();
